import {Size} from '../../generated/types';
import {CreatureTypes} from '../enums';
import {humanEnumeration} from '../utils';

const monstersTypesSwarm: Record<string, string> = {
	aberration: 'аберраций',
	celestial: 'небожителей',
	construct: 'конструкций',
	dragon: 'драконов',
	elemental: 'элементалей',
	fey: 'фей',
	fiend: 'бестий',
	giant: 'великанов',
	humanoid: 'гуманоидой',
	monstrosity: 'монстров',
	ooze: 'жиж',
	plant: 'растений',
	undead: 'нежити',
	beast: 'животных',
};

export function toMonsterTypeString(types: string[], swarmSize?: Size | null) {
	let result = '';

	result += humanEnumeration(
		types?.map((type) => {
			if (swarmSize) return 'стая ' + monstersTypesSwarm[type] || type;
			return CreatureTypes[type] || type;
		}),
		'или',
	);

	//if (types?.length > 1) result += ' (Your Choice)';

	return result;
}
